

import { http } from "@/config/httpCommon";
import { handleResponseException, logData } from "@/helpers/Helpers";
import ErrorMessages from "@/mixins/ErrorMessages";
import moment from "moment";
import { Component, Mixins, Prop, Vue } from 'vue-property-decorator';


@Component<AddUpdateComment>({
  components: {

  },
  filters: {
    initials(value: string) {
      if (value) {
        let value_array = value.split(" ");

        // Select the first letter of the name
        let first_letter = value.charAt(0);
        let last_letter = "";
        if (value_array.length > 1) {
          last_letter = value_array[value_array.length - 1].charAt(0);
        }
        let initial_letters = first_letter + last_letter;
        // Return the initials
        return initial_letters.toUpperCase();
      } else {
        return "";
      }

    }
  },
  created() {
    let self = this;
    if(self.comment_obj) {
      //if action type is edit then it means we are editing existing comment
      if(self.action == "edit") {
        self.comment_message = self.comment_obj.message;
        self.comment_obj.files.forEach((comment_obj_file: Record<any, any>) => {
          self.comment_files.push({
            file: comment_obj_file.url, file_preview: `${self.storage_url}/${comment_obj_file.url}`, name: comment_obj_file.name, extension: comment_obj_file.extension
          })
        })
      } else if(self.action == "reply") { //if action type is reply then it means we are adding reply to existing comment
        self.parent_message = self.comment_obj.message;
        self.parent_message_id = self.comment_obj.id;
      }
    }
  }
})
export default class AddUpdateComment extends Mixins(ErrorMessages) {
  /*
  * props section starts
  * */
  @Prop({required: false}) readonly comment_obj !: Record<any, any>
  @Prop({required: true}) readonly url !: string
  @Prop({required: true}) readonly order_item_id !: string
  @Prop({required: false, default: 'add'}) readonly action !: string
  /*
  * props section ends
  * */

  /*
  * Store section start
  * */

  public customer =  this.$store.getters.getCustomer;

  /*
  * Store section ends
  * */

  /*
  * data section starts
  * */
  public storage_url = process.env.VUE_APP_FILE_URL
  public logData = logData;
  public comment_message:string|null = null;
  public comment_files: Record<any, any>[] = [];
  public removed_files: File[] = [];
  public parent_message: null|string= null;
  public parent_message_id: null|number = null;
  public adding_comment = false;
  public user = JSON.parse(localStorage.getItem('user'));
  public selected_attachment = [];
  /*
  * data section ends
  * */

  async uploadFiles(event: Record<any, any>) {
    let self = this;
    let uploaded_files = event.target.files;
    //let allowed_file_types = ["jpg", "jpeg", "pdf", 'png']
    let not_allowed_file_types = ["php", "exe", "bat", 'sh']
    let rejected_files = [];
    for (let uploaded_file of uploaded_files) {
      let file_name = uploaded_file.name;
      let file_extension = file_name.substring(file_name.lastIndexOf('.') + 1).toLowerCase();
      if(!not_allowed_file_types.includes(file_extension)) {
        let file_preview = await self.createFilePreview(uploaded_file)
        self.comment_files.push({
          file: uploaded_file, file_preview: file_preview, name: file_name, extension: file_extension
        })
      } else {
        rejected_files.push(file_name)
      }
    }
    let rejected_files_length = rejected_files.length;
    if(rejected_files_length > 0) {
      console.warn(`Uploaded files(${rejected_files_length}) has been rejected. The rejected files are`+ rejected_files.toString())
    }
    event.target.files = null;
  }

  async createFilePreview(file: File) {
    let result_base64 = await new Promise((resolve) => {
      let fileReader = new FileReader();
      fileReader.onload = (e) => resolve(fileReader.result);
      fileReader.readAsDataURL(file);
    });
    return result_base64;
  }


  previewPdf(pdf_file_object: Record<any, any>) {
    const pdfWindow:Record<any,any>|null = window.open("");
    // let data = '<object data="' + pdf_file_object.file_preview + '" width="100%" height="100%">';
    let data = `<object data="${pdf_file_object.file_preview}" width="100%" height="100%">
                    <embed ng-srs="${pdf_file_object.file_preview}" width="100%" height="100%"></embed>
                </object>`;
    pdfWindow? pdfWindow.document.write(data) : null;
  }

  async getPayloadData() {
    let self = this;
    let form_data = new FormData();
    if(self.comment_message) {
      form_data.append('message', self.comment_message);
    }
    self.comment_files.forEach((comment_file: Record<any, any>) => {
      //this check is due to that file can have string or file object. String will be in case when we user edit comment and we need to show existing file
      if (comment_file.file.constructor.name == "File") {
        form_data.append('files[]', comment_file.file);
      }
    });
    self.removed_files.forEach((removed_file: File) => {
      form_data.append('removed_files[]', removed_file);
    });
    if(self.parent_message_id) {
     if(self.parent_message) {
       form_data.append('parent_message', self.parent_message);
     }
      form_data.append('parent_message_id', self.parent_message_id.toString());
    }
    form_data.append('order_item_id', self.order_item_id);
    return form_data;
  }

  async handleCommentAction() {
    let self = this;
    if(self.comment_message || self.comment_files.length >0) {
      self.adding_comment = true;
      let form_data = await self.getPayloadData();
      http.post(self.url, form_data).then((successResponse: Record<any, any>) => {
        let response_data = successResponse.data;
        self.adding_comment = false;
        self.hideCommentBox();
        self.$emit("commentActionCompleted", response_data.result.item_activity_comment);
      }).catch((errorResponse: any) => {
        self.adding_comment = false;
        handleResponseException(errorResponse)
      })
    } else {
      alert("Can not add empty comment")
    }

  }


  removeUploadedFile(file_index: number) {
    let self = this;
    let remove_file = self.comment_files[file_index];
    //if removed file type is string then it means user is deleting existing file of comment and we remove it from database
    if(self.action == "edit" && remove_file.file.constructor.name == "String") {
      self.removed_files.push(self.comment_files[file_index].file)
    }
    self.comment_files.splice(file_index, 1);
  }

  hideCommentBox() {
    this.$emit('hideCommentBox')
  }

  downloadAttachment(file){
    console.log(file);
    let attachment_element = document.createElement('a');
    this.selected_attachment.push(file.name);
    let index = this.selected_attachment.findIndex((attachment) => {
      return attachment === file.name;
    });
    let urls = [{url:file.url,ext:file.extension}];
    http.post(`convert-file-to-base64`, {urls: urls}).then((response) => {
      let attachment = response.data.image_urls[0].url;
      if(attachment){
        const d = new Date()
        let time = d.getTime()
        attachment_element.setAttribute('id', `${time}`);
        attachment_element.setAttribute('href', attachment);
        attachment_element.setAttribute('download', `${file.name}.${file.extension}`);
        attachment_element.style.display = 'none';
        document.body.appendChild(attachment_element);
        attachment_element.click();
        document.body.removeChild(attachment_element);
        this.selected_attachment.splice(index,1);
      }
      else{
        this.showError('File path is not valid');
        this.selected_attachment.splice(index,1);
      }
    }).catch((errorResponse) => {
      this.selected_attachment.splice(index,1);
    });
  }

}
